var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85822 15.9993H5.56597C5.80157 15.9993 5.99254 15.8083 5.99254 15.5727V8.10821C5.99254 7.87259 5.80157 7.68164 5.56597 7.68164H3.85822C3.62259 7.68164 3.43164 7.87259 3.43164 8.10821V15.5727C3.43164 15.8083 3.62259 15.9993 3.85822 15.9993Z",
    fill: "#142454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85822 6.36964H5.56597C5.80157 6.36964 5.99254 6.17867 5.99254 5.94306V4.42657C5.99254 4.19097 5.80157 4 5.56597 4H3.85822C3.62259 4 3.43164 4.19097 3.43164 4.42657V5.94306C3.43164 6.17867 3.62259 6.36964 3.85822 6.36964Z",
    fill: "#142454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9256 8.54817C15.6856 8.23229 15.3318 7.97252 14.8639 7.7689C14.396 7.56543 13.8796 7.46362 13.3145 7.46362C12.1674 7.46362 11.1955 7.90139 10.3986 8.77709C10.2401 8.95133 10.1248 8.91324 10.1248 8.67761V8.10895C10.1248 7.87332 9.93377 7.68238 9.69817 7.68238H8.17267C7.93704 7.68238 7.74609 7.87332 7.74609 8.10895V15.5735C7.74609 15.8091 7.93707 16.0001 8.17267 16.0001H9.88042C10.116 16.0001 10.307 15.8091 10.307 15.5735V12.9775C10.307 11.896 10.3723 11.1547 10.5029 10.7538C10.6335 10.3528 10.8751 10.0308 11.2274 9.78775C11.5799 9.54471 11.9778 9.42313 12.4214 9.42313C12.7677 9.42313 13.0639 9.50821 13.31 9.67839C13.5561 9.84854 13.7338 10.0869 13.8432 10.3938C13.9526 10.7006 14.0073 11.3766 14.0073 12.4216V15.5735C14.0073 15.8091 14.1982 16.0001 14.4338 16.0001H16.1416C16.3772 16.0001 16.5681 15.8091 16.5681 15.5735V11.3462C16.5681 10.5989 16.521 10.0247 16.4269 9.62371C16.3329 9.22273 16.1657 8.86421 15.9256 8.54817Z",
    fill: "#142454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLinkedin);
export default __webpack_public_path__ + "static/media/White_Linkedin.826968f272822b762988c475ff283146.svg";
export { ForwardRef as ReactComponent };